import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import MiniQuiz from "@/components/MiniQuiz";
import NotifySection from "@/components/NotifySection";
import Footer from "@/components/Footer";
import ComingSoon from "@/components/ComingSoon";

export default function Landing() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings(r.data))
      .catch(() =>
        setSettings({ coming_soon: false, playstore_url: "https://play.google.com/store" })
      );
  }, []);

  if (!settings) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#08090E]">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#222738] border-t-[#00F0FF]" />
      </div>
    );
  }

  if (settings.coming_soon) {
    return <ComingSoon />;
  }

  return (
    <div className="bg-[#08090E] text-white">
      <Navbar playstoreUrl={settings.playstore_url} />
      <Hero playstoreUrl={settings.playstore_url} />
      <Marquee />
      <Manifesto />
      <MiniQuiz />
      <NotifySection playstoreUrl={settings.playstore_url} />
      <Footer />
    </div>
  );
}
